import apiClient from "../api_client/apiClient";

export const notificationService = {
  list: (unreadOnly = false) => apiClient.get("/genesis/notifications", { unread_only: unreadOnly }),
  markRead: (id) => apiClient.post(`/genesis/notifications/${id}/read`),
  getPreferences: () => apiClient.get("/genesis/notifications/preferences"),
  updatePreferences: (patch) => apiClient.put("/genesis/notifications/preferences", patch),
};
